import { RootState } from '../store';

export const getCustomerByPhoneSelector = (state: RootState) => state.customerReducer.customerByPhone;
export const getIsLoadingCustomerSelector = (state: RootState) => state.customerReducer.isLoading;
export const getIsRequestedSelector = (state: RootState) => state.customerReducer.isRequested;
